import { SelectOption } from '@synqo/frontend-component-library';

export type InvoiceTableModes = 'all' | 'opos' | 'export';

export const invoiceTableModes: SelectOption<InvoiceTableModes>[] = [
    {
        name: 'rechnungen',
        label: 'Rechnungen',
        value: 'all',
    },
    {
        name: 'opos',
        label: 'Offene Posten',
        value: 'opos',
    },
    {
        name: 'export',
        label: 'FiBu Übergabe',
        value: 'export',
    },
];
